<template>
  <b-container fluid class="newcart_container" style="position:relative;">
    <HeaderBackMobile :noCart="true" />
    <b-row class="new_cart_items_list" style="margin-top:8px;padding-bottom:18px;height:38px;border-bottom: 1px solid #F7F7F8;">
      <b-col class="newcart_title mt-2">Meu Carrinho - Subtotal R$ {{formatPrice($store.state.cart.total)}} </b-col>
    </b-row>
    <b-row class="new_cart_items_list">
      <b-col style="height:calc(100vh - 251px); overflow-y:auto;overflow-x:hidden;">
        <b-row v-for="(product, idx) in $store.state.cart.products" v-bind:key="idx" style="padding:8px 8px 0 8px;">
          <b-col cols="8" class="newcart_product_name mt-2" style="font-size:17px;min-height:32px;line-height:16px;">
            {{(product.name).toLowerCase()}}
          </b-col>
          <b-col cols="4" class="text-right mt-2">
            R$ {{formatPrice(product.qtd * product.price)}}
          </b-col>



          <b-col cols="12" class="mb-2" style="font-size:11px;" v-html="priceConditionals(product)"></b-col>


          <b-col cols="3" class="justify-content-center align-items-center" style="border-bottom: 1px solid #F7F7F8;display: flex;">
            <img @error="imgUrlAlt" class="newcart_imageprod" v-if="product.image" :src="productImageURI + '/' + product.image" />
            <img class="newcart_imageprod" v-else src="https://cdnimages.opa4.store/img/fixedimg/no-picture.png" />
          </b-col>
          <b-col style="border-bottom: 1px solid #F7F7F8;padding-bottom:16px">
            <b-row v-if="product.options" class="mt-2 mb-2">
              <b-col>
                <b-row v-for="(option, idxo) in product.options" v-bind:key="idxo" >
                  <b-col cols="12" class="newcart_product_name" style="color:#666;">
                    {{option.label}}:
                  </b-col>
                  <b-col cols="12" class="newcart_product_name" v-for="(choice, idxc) in option.choices" v-bind:key="idxc" style="color:#666;">
                    <li>{{choice.quantity}}x {{choice.label}} {{choice.price && choice.price > 0 ? ' + R$' + formatPrice(choice.price) : ''}}</li>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>


            <b-row style="margin-top:4px;">

              <b-col v-if="product.observation" cols="6" class="newcart_product_name" style="color:#666;"><b><i>Obs: {{product.observation}}</i></b></b-col>
              <b-col cols="6" v-else></b-col>


              <b-col cols="6" class="align-self-end" style="display:inline-flex;text-align:center;">
                <div class="newcart_minus" @click="minusQtd(product.id, product.productViewId, product.productCartId)" :style="{color:getCssColor('primary_bt')}">
                  <font-awesome-icon v-if="getQtd(product.id, product.productViewId) > 1" style="font-size:14px;" :icon="['far', 'minus']"/>
                  <font-awesome-icon v-else style="font-size:14px;" :icon="['far', 'trash']"/>
                </div>
                <div class="newcart_quantity">
                  {{getQtd(product.id, product.productViewId, product.productCartId)}}
                </div>
                <div class="newcart_plus" @click="plusQtd(product.id, product.productViewId, product.productCartId)" :style="{color:getCssColor('primary_bt')}">
                  <font-awesome-icon style="font-size:14px;" :icon="['far', 'plus']"/>
                </div>
              </b-col>
              
            </b-row>
            
          </b-col>
        </b-row>
        <b-row v-if="!$store.state.cart.products.length">
          <b-col>
            
            <div style="height:50px;opacity:0.74;text-align:center;margin-top:80px;font-size:18px">
              <font-awesome-icon style="color:#312922;font-size:32px;opacity:0.74;" :icon="['fal', 'heart-broken']"/><br/><br/>
              Seu carrinho está vazio
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="$store.state.cart.products.length" style="height:120px;background-color:#fafafa;">
      <b-col>
        <b-row style="margin-top:8px;">
          <b-col style="text-align:center;">
            <button @click="back()" class="newcart_pay_button_wire" style="background-color:#fafafa;" :style="{color:getCssColor('primary_bt')}">CONTINUAR COMPRANDO</button>
          </b-col>
        </b-row>
        <b-row style="margin-top:8px;">
          <b-col style="text-align:center;">
            <button @click="startCheckout()" class="newcart_pay_button" :style="{backgroundColor:getCssColor('primary_bt')}">FINALIZAR COMPRA</button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- cover checkout -->
    <div :class="{newcart_cover_checkout: !coverCheckout, newcart_cover_oppen: coverCheckout}" style="background: linear-gradient(180deg, rgba(255, 255, 255, 0.02) 0%, #FFFFFF 30px);">
      <div style="height:calc(100vh);width:100vw;">
        <div class="covercheckout_dimiss" @click="coverCheckout = false">
          <font-awesome-icon style="font-size:28px;margin-top:30px;" :style="{color:getCssColor('primary_bt')}" :icon="['fal', 'angle-down']"/>
        </div>
        <div style="position:absolute;top:60px;width:100vw;height:calc(100vh - 60px);overflow-y:auto;overflow-x:hidden;">
          <b-container>
            <b-row style="margin-top:16px;height:30px;border-bottom:1px solid #F7F7F8;">
              <b-col style="font-weight: 500; font-size: 15px; color: #121C2A;">1. Tipo de Entrega</b-col>
            </b-row>

            <b-row style="margin-top:16px;">
              <!-- express -->
              <b-col>
                <div @click="selectDeliveryType('delivery_express')" class="newcart_box_delivery_choice" :class="{selectec_shadow:isSelectDeliveryType('delivery_express')}">
                  <div style="width:100%;height:40px;padding:8px;">
                    <div style="border:2px solid;width:12px;height:12px;border-radius:6px;"  :style="{'border-color':getCssColor('primary_bt','light-2'), backgroundColor:(isSelectDeliveryType('delivery_express')?getCssColor('primary_bt'):getCssColor('primary_bt','light-2'))}"></div>
                  </div>
                  <p style="font-weight: 500;font-size: 12px;line-height: 16px;padding:8px;" :style="{color:getCssColor('primary_bt')}">Entrega<br/>Expressa</p>
                </div>
              </b-col>
              <!-- schedule -->
              <b-col v-if="getChoicedCompany.agenda">
                <div @click="selectDeliveryType('delivery_schedule')" class="newcart_box_delivery_choice" :class="{selectec_shadow:isSelectDeliveryType('delivery_schedule')}">
                  <div style="width:100%;height:40px;padding:8px;">
                    <div style="border:2px solid;width:12px;height:12px;border-radius:6px;"  :style="{'border-color':getCssColor('primary_bt','light-2'), backgroundColor:(isSelectDeliveryType('delivery_schedule')?getCssColor('primary_bt'):getCssColor('primary_bt','light-2'))}"></div>
                  </div>
                  <p style="font-weight: 500;font-size: 12px;line-height: 16px;padding:8px;" :style="{color:getCssColor('primary_bt')}">Agendar<br/>entrega</p>
                </div>
              </b-col>
              <!-- store taking -->
              <b-col v-if="isStoreTaking()">
               <div @click="selectDeliveryType('delivery_take')" class="newcart_box_delivery_choice" :class="{selectec_shadow:isSelectDeliveryType('delivery_take')}">
                  <div style="width:100%;height:40px;padding:8px;">
                    <div style="border:2px solid;width:12px;height:12px;border-radius:6px;"  :style="{'border-color':getCssColor('primary_bt','light-2'), backgroundColor:(isSelectDeliveryType('delivery_take')?getCssColor('primary_bt'):getCssColor('primary_bt','light-2'))}"></div>
                  </div>
                  <p style="font-weight: 500;font-size: 12px;line-height: 16px;padding:8px;" :style="{color:getCssColor('primary_bt')}">Retirar em<br/>loja</p>
                </div>
              </b-col>
            </b-row>

            <!-- schedule type -->
            <b-row style="margin-top:32px;height:40px;">
              <b-col style="font-weight: 500; font-size: 15px; color: #121C2A;">2. Dados da {{(deliveryType === 'delivery_take' ? 'Retirada' : 'Entrega')}}</b-col>
            </b-row>

            <!-- express time -->
            <b-row v-if="deliveryType === 'delivery_express'" style="border-top:1px solid #F7F7F8;">
              <b-col style="margin:0px 16px;border-bottom:1px solid #F7F7F8;padding:8px 8px; line-height:15px;">
                <b-row>
                  <b-col cols="2" style="text-align:center;">
                    <font-awesome-icon style="color:#525962;font-size:24px;" :icon="['fal', 'alarm-clock']"/>
                  </b-col>
                  <b-col>
                      <span style="font-weight: 500;font-size: 15px;color: #121C2A;">Prazo Estimado</span><br/>
                      <span style="font-size: 14px;color: #525962;">{{calculateEstimateExpress()}}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <!-- -->

            <!-- schedule time -->
            <b-row v-else-if="deliveryType === 'delivery_schedule'" style="border-top:1px solid #F7F7F8;">
              <b-col @click="scheduleModal=true" style="margin:0px 16px;border-bottom:1px solid #F7F7F8;padding:8px 8px; line-height:15px;">
                <b-row>
                  <b-col cols="2" style="text-align:center;">
                    <font-awesome-icon style="color:#525962;font-size:24px;" :icon="['fal', 'alarm-clock']"/>
                  </b-col>
                  <b-col>
                      <span style="font-weight: 500;font-size: 15px;color: #121C2A;">Horário de Entrega</span><br/>
                      <span style="font-size: 14px;color: #525962;">{{scheduleInfo}}</span>
                  </b-col>
                  <b-col cols="2">
                    <font-awesome-icon style="color:#525962;font-size:24px;" :icon="['fal', 'angle-right']"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <!-- -->

            <!-- delivery take -->
            <b-row v-else style="border-top:1px solid #F7F7F8;">
              <b-col style="margin:0px 16px;border-bottom:1px solid #F7F7F8;padding:8px 8px; line-height:15px;">
                <b-row>
                  <b-col cols="2" style="text-align:center;">
                    <font-awesome-icon style="color:#525962;font-size:24px;" :icon="['fal', 'store']"/>
                  </b-col>
                  <b-col>
                      <span style="font-weight: 500;font-size: 15px;color: #121C2A;">Locais de retirada</span><br/>
                      <span style="font-size: 14px;color: #525962;" v-html="getPinAddress()"></span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <!-- addr not marketplace or locked -->
            <b-row v-if="!$store.state.company.block_address_navigation || $store.state.company.block_address_navigation === 'NO'" >
              <b-col @click="addressModal=true" style="margin:0 16px;border-bottom:1px solid #F7F7F8;padding:8px 8px;line-height:15px;">
                <b-row align-v="center">
                  <b-col cols="2" style="text-align:center;">
                    <font-awesome-icon style="color:#525962;font-size:24px;" :icon="['fal', 'map-marker-alt']"/>
                  </b-col>
                  <b-col>
                      <span style="font-weight: 500;font-size: 15px;color: #121C2A;">Endereço de {{(deliveryType === 'delivery_take' ? 'Pagamento' : 'Entrega')}}</span><br/>
                      <span v-if="selectedAddr" style="font-size: 14px;color: #525962;">{{selectedAddr.shortName}}</span>
                      <span v-else style="font-size: 14px;color: #b73a2c;">selecione um endereço</span>
                  </b-col>
                  <b-col cols="2">
                    <font-awesome-icon style="color:#525962;font-size:24px;" :icon="['fal', 'angle-right']"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <!-- -->

            <!-- addr locked -->
            <b-row v-else >
              <b-col style="margin:0 16px;border-bottom:1px solid #F7F7F8;padding:8px 8px;line-height:15px;">
                <b-row align-v="center">
                  <b-col cols="2" style="text-align:center;">
                    <font-awesome-icon style="color:#525962;font-size:24px;" :icon="['fal', 'map-marker-alt']"/>
                  </b-col>
                  <b-col>
                      <span style="font-weight: 500;font-size: 15px;color: #121C2A;">Endereço de {{(deliveryType === 'delivery_take' ? 'Pagamento' : 'Entrega')}}</span><br/>
                      <span style="font-size: 14px;color: #525962;">{{$store.state.selectedAddressShort}}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <!-- -->

            <b-row style="margin-top:32px;height:40px;">
              <b-col style="font-weight: 500; font-size: 15px; color: #121C2A;">3. Pagamento</b-col>
            </b-row>

            <!-- cupom -->
            <b-row>
              <b-col  style="margin:0 16px;border-bottom:1px solid #F7F7F8;padding:8px 8px;line-height:15px;">
                <b-row align-v="center">
                  <b-col @click="cupomsModal=true" cols="2" style="text-align:center;">
                    <font-awesome-icon style="color:#525962;font-size:24px;" :icon="['fal', 'badge-dollar']"/>
                  </b-col>
                  <b-col @click="cupomsModal=true">
                      <span style="font-weight: 500;font-size: 15px;color: #121C2A;">Cupom</span><br/>
                      <span v-if="!$store.state.cupomObject" style="font-size: 14px;color: #525962;">insira um cupom</span>
                      <span v-else style="font-size: 14px;color: #525962;">{{$store.state.cupomObject.code}} {{$store.state.cupomObject.discount_type==='PERCENTAGE'? '-' + $store.state.cupomObject.discount_value + '%' : '- R$' + $store.state.cupomObject.discount_value}}</span>
                  </b-col>
                  <b-col @click="cupomsModal=true" cols="2"  v-if="!$store.state.cupomObject">
                    <font-awesome-icon style="color:#525962;font-size:24px;" :icon="['fal', 'angle-right']"/>
                  </b-col>
                  <b-col cols="2"  v-else @click="removeCupom()">
                    <font-awesome-icon style="color:#871b20;font-size:20px;" :icon="['fal', 'trash']"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <!-- -->

            <!-- cartao -->
            <b-row>
              <b-col @click="cardModal=true" style="margin:0 16px;border-bottom:1px solid #F7F7F8;padding:8px 8px;line-height:15px;">
                <b-row align-v="center">
                  <b-col cols="2" style="text-align:center;">
                    <font-awesome-icon v-if="selectedCard" style="color:#525962;font-size:24px;" :icon="[cardLib(selectedCard.flag), cardIcon(selectedCard.flag)]"/>
                    <font-awesome-icon v-else style="color:#525962;font-size:24px;" :icon="['fal', 'credit-card-front']"/>
                  </b-col>
                  <b-col>
                      <span style="font-weight: 500;font-size: 15px;color: #121C2A;">Cartão de Crédito</span><br/>
                      <span v-if="selectedCard" style="font-size: 14px;color: #525962;">{{selectedCard.number}}</span>
                      <span v-else style="font-size: 14px;color: #b73a2c;">selecione um cartão de crédito</span>
                  </b-col>
                  <b-col cols="2">
                    <font-awesome-icon style="color:#525962;font-size:24px;" :icon="['fal', 'angle-right']"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <!-- -->

            <b-row style="margin-top:32px;height:40px;">
              <b-col style="font-weight: 500; font-size: 15px; color: #121C2A;">4. Resumo da Compra</b-col>
            </b-row>

            <!-- produtos comprados -->
            <b-row style="height:38px;">
              <b-col style="margin:0 16px;border-bottom:1px solid #F7F7F8;padding:8px 8px;line-height:15px;">
                <b-row align-v="center">
                  <b-col>
                      <span style="font-size: 15px;color: #525962;">Produtos Comprados</span><br/>
                  </b-col>
                  <b-col cols="4" style="font-weight:500;text-align:right;color: #121C2A;">
                    R$ {{formatPrice($store.state.cart.total)}}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <!-- -->

            <!-- cupom de desconto -->
            <b-row style="height:38px;">
              <b-col style="margin:0 16px;border-bottom:1px solid #F7F7F8;padding:8px 8px;line-height:15px;">
                <b-row align-v="center">
                  <b-col>
                      <span style="font-size: 15px;color: #525962;">Cupom de Desconto</span><br/>
                  </b-col>
                  <b-col cols="4" style="font-weight:500;text-align:right;color: #075122;">
                    - R$ {{formatPrice($store.state.cart.cupomDiscount)}}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <!-- -->

            <!-- frete -->
            <b-row style="height:38px;">
              <b-col style="margin:0 16px;border-bottom:1px solid #F7F7F8;padding:8px 8px;line-height:15px;">
                <b-row align-v="center">
                  <b-col>
                      <span style="font-size: 15px;color: #525962;">Frete / Serviço</span><br/>
                  </b-col>
                  <b-col cols="4" style="font-weight:500;text-align:right;color: #121C2A;">
                    R$ {{formatPrice($store.state.cart.deliveryTax + getServiceFee())}}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <!-- -->

            <!-- total -->
            <b-row style="height:38px;">
              <b-col style="margin:0 16px;border-bottom:1px solid #F7F7F8;padding:8px 8px;line-height:15px;">
                <b-row align-v="center">
                  <b-col>
                      <span style="font-weight:500;font-size: 15px;color: #121C2A;">Total</span><br/>
                  </b-col>
                  <b-col cols="4" style="font-weight:500;text-align:right;color: #121C2A;">
                    R$ {{ getTotalCartPrice() }}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <!-- -->

            <b-row style="margin-top:20px;margin-bottom:20px;padding-bottom:80px;">
              <b-col style="text-align:center;">
                <button @click="openCVV()" class="newcart_pay_button" :style="{backgroundColor:getCssColor('primary_bt')}">CONCLUIR PAGAMENTO</button>
              </b-col>
            </b-row>


          </b-container>
        </div>
      </div>
    </div>

    <!-- address list -->

    <!-- address modal -->
    <OpaSlideModal 
      v-if="$store.state.user"
      title="Escolher Endereço" 
      direction="right"
      v-model="addressModal"
      @slideModalClose="() => addressModal = false"
      >
      <b-row style="overflow-y:auto; overflow-x:none; height:calc(100vh - 196px);">
        <b-col>
          <AddressList @selectedAddress="(addressId) => selectAddress(addressId)" />
        </b-col>
      </b-row>
      <b-row style="position:absolute;bottom:0px;height:140px;background-color:rgb(254, 254, 254);width:100%">
        <b-col>
          <b-row style="margin-top:10px;">
            <b-col style="text-align:center;">
              <button
                :style="{color: getCssColor('primary_bt'),
                borderColor: getCssColor('primary_bt')}"
                class="newcart_pay_button_wire"
                @click="newAddress()"
                  >NOVO ENDEREÇO</button>
            </b-col>
          </b-row>
          <b-row  style="margin-top:10px;">
            <b-col  style="text-align:center;">
              <button
                class="newcart_pay_button"
                @click="addressModal = false"
                :style="{backgroundColor: getCssColor('primary_bt')}"
                  >CONTINUAR</button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </OpaSlideModal>

    <!-- cards modal -->
    <OpaSlideModal 
      v-if="$store.state.user"
      title="Escolher Cartão de Crédito" 
      direction="right"
      v-model="cardModal"
      @slideModalClose="() => cardModal = false"
      >
      <b-row style="overflow-y:auto; overflow-x:none; height:calc(100vh - 196px);">
        <b-col>
          <CardsList @selectedCard="(cardId) => selectCard(cardId)" />
        </b-col>
      </b-row>
      <b-row style="position:absolute;bottom:0px;height:140px;background-color:rgb(254, 254, 254);width:100%">
        <b-col>
          <b-row style="margin-top:10px;">
            <b-col style="text-align:center;">
              <button
                :style="{color: getCssColor('primary_bt'),
                borderColor: getCssColor('primary_bt')}"
                class="newcart_pay_button_wire"
                @click="newCard()"
                  >NOVO CARTÃO DE CRÉDITO</button>
            </b-col>
          </b-row>
          <b-row  style="margin-top:10px;">
            <b-col  style="text-align:center;">
              <button
                class="newcart_pay_button"
                @click="cardModal = false"
                :style="{backgroundColor: getCssColor('primary_bt')}"
                  >CONTINUAR</button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </OpaSlideModal>


    <!-- cupoms modal -->
    <OpaSlideModal 
      v-if="$store.state.user"
      title="Cupom de Desconto" 
      direction="right"
      v-model="cupomsModal"
      @slideModalClose="() => cupomsModal = false"
      >
      <b-row align-h="center"  style="height:calc(100vh - 176px);">
        <b-col cols="11" style="margin-top:20px;height:50px;font-size:16px;">
          Insira o código do cupom e clique em validar para obter o desconto.<br/>
          <b style="font-size:12px;">Atenção: letras maiúsculas e minúsculas são diferentes.</b>
        </b-col>
        <b-col cols="10" style="height:150px;">
          <OpaInputText v-model="$store.state.cupomCode" placeholder="código do cupom" :icon="['fal', 'badge-dollar']" />
        </b-col>
      </b-row>
      <b-row style="position:absolute;bottom:0px;height:80px;background-color:rgb(254, 254, 254);width:100%">
        <b-col>
          <b-row  style="margin-top:10px;">
            <b-col  style="text-align:center;">
              <button
                class="newcart_pay_button"
                @click="validateCupom()"
                :style="{backgroundColor: getCssColor('primary_bt')}"
                  >VALIDAR</button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </OpaSlideModal>


    <!-- CVV modal -->
    <div v-if="cvvModal" @click="cvvModal=false" style="height: auto;
        min-height:100vh;
        width: 100vw;
        opacity: 0.49;
        background-color: #2A2531;
        position: fixed;
        top: 0px;
        left:0px;
        z-index:28001;"></div>
    <div v-if="cvvModal" style="background-color:#FFFFFF;position:fixed;bottom:45px;width:310px;height:152px;z-index:28002;left:calc(50vw - 155px);box-shadow: 0 4px 11px 0 rgba(0,0,0,0.35);border-radius:4px;">
      <b-container fluid>
        <b-row>
          <b-col style="
          margin-top:8px;
                font-weight: 500;
                font-size: 14px;
                line-height: 18px;
                text-align: center;
                text-transform: uppercase;
                color: #000000;">Digite o Código de Segurança<br/><span style="font-size:11px;">3 ou 4 dígitos no verso do cartão de crédito</span></b-col>
        </b-row>
        <b-row align-v="center" style="border-top: 1px solid #DADADA;margin-top:8px;padding-top:4px;">
          <b-col cols="1">
            <font-awesome-icon style="color:#525962;font-size:20px;margin-top:10px;" :icon="[cardLib(selectedCard.flag), cardIcon(selectedCard.flag)]"/>
          </b-col>
          <b-col style="font-size:12px;text-align:right;margin-top:6px;">
            {{selectedCard.number}}
          </b-col>
          <b-col >
            <input type="number" id="cvvInput" ref="cvvInput" style="width:120px;font-size:23px;letter-spacing:8px;text-align:center;border:1px solid #000000;border-radius:4px;" v-model="$store.state.checkoutViewCVV" placeholder=" ____">
          </b-col>
        </b-row>

        <b-row style="margin-top:8px;">
          <b-col style="text-align:center;">
            <button @click="checkout()" style="width:100px;height:30px;font-size:12px;background-color:#3E63B5;border-radius:4px;border-color:#ffffff;color:#ffffff;">CONFIRMAR</button>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <!-- modal agendamento -->
    <OpaSlideModal 
      v-if="getChoicedCompany.agenda && $store.state.user"
      title="Escolha Agendamento" 
      direction="right"
      v-model="scheduleModal"
      @slideModalClose="() => scheduleModal = false"
      >
      <b-row align-h="center"  style="height:calc(100vh - 176px);">
        <b-col>
          <ScheduleList @selectedSchedule="(schedule, time) => setSchedule(schedule, time)" @firstSchedule="(schedule, time) => setFirstSchedule(schedule, time)"/>
        </b-col>
      </b-row>
      <b-row style="position:absolute;bottom:0px;height:80px;background-color:rgb(254, 254, 254);width:100%">
        <b-col>
          <b-row  style="margin-top:10px;">
            <b-col  style="text-align:center;">
              <button
                class="newcart_pay_button"
                @click="scheduleModal = false"
                :style="{backgroundColor: getCssColor('primary_bt')}"
                  >CONFIRMAR</button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </OpaSlideModal>



  </b-container>
    
</template>

<script>
import cartMixin from '@/mixins/cartMixin'
import formaters from '@/mixins/formaters'
import colors from '@/mixins/colors'
import UserConn from '@/connection/user'
import LocConn from '@/connection/location'
import CartConn from '@/connection/cart'
import HeaderBackMobile from '@/components/HeaderBackMobile'
import OpaSlideModal from '@/components/OpaSlideModal'
import OpaInputText from '@/components/OpaInputText'
import AddressList from '@/components/AddressList'
import CardsList from '@/components/CardsList'
import { EventBus } from '@/behaviours/event-bus'
import { mapGetters } from 'vuex'
import PromotionsConn from '@/connection/promotions'
import TransactionConn from '@/connection/transactions'
import ScheduleList from '@/components/ScheduleList'
import navigation from '@/mixins/navigation'

export default {
  name: 'Cart',
  data () {
    return {
      coverCheckout: false,
      deliveryType: 'delivery_express',
      addressModal: false,
      cardModal: false,
      cupomsModal: false,
      cvvModal: false,
      scheduleModal: false,


      delivery: 'true',
      invalidAddress: false,
      invalidCard: false,
      invalidCVV: false,
      deliveryTax: 0,
      checkoutLocked: true,
      infoDelivery: '',
      infoFinish: '',
      mayIChoiceDelivery: false,
      mayIFinish: true,

      selectedAddr: null,
      selectedCard: null,

      scheduleInfo: null,
      scheduleTime: null,
      firstScheduleInfo: '',
      firstScheduleTime: null,
      lastSelectedInfo: null,
      lastSelectedTime: null,

      retry: 0,

      timeoutsPurchase: []
    }
  },
  mixins: [colors, formaters, cartMixin, navigation],

  components: {HeaderBackMobile, OpaSlideModal, AddressList, CardsList, OpaInputText, ScheduleList},

  computed: {
    productImageURI () {
      return this.$store.getters.getProductImageURI
    },

    ...mapGetters([ 'getChoicedCompany' ]),
    
  },

  created () {

    if (!this.$store.state.cart.cupomDiscount) {
      this.$store.state.cart.cupomDiscount = 0
    }

    if (this.$router.currentRoute.query.cover) {
      window.scrollTo(0, 0)
      this.coverCheckout = true
    }

    // if the address is locked, so need to be the selectedAddressId in the store
    if (this.$store.state.company.block_address_navigation && this.$store.state.company.block_address_navigation !== 'NO') {
      console.log('GET THE SELECTED ADDRESS ID', this.$store.state.selectedAddressId)
      this.$store.state.checkoutViewSelectedAddress =  this.$store.state.selectedAddressId
    } else if (this.$store.state.checkoutViewSelectedAddress === '0' && this.$store.state.user && this.$store.state.user.adresses.length > 0){
      // else, take the last if user exists
      console.log('GET THE LAST ADDR ID')
      this.$store.state.checkoutViewSelectedAddress = this.$store.state.user.adresses[this.$store.state.user.adresses.length -1].id
    }

    if (this.$store.state.checkoutViewSelectedCard === '0' && this.$store.state.user && this.$store.state.user.cards.length > 0){
      this.$store.state.checkoutViewSelectedCard = this.$store.state.user.cards[this.$store.state.user.cards.length -1].id
    }

    
  },

  destroyed() {
    for (var i=0; i<this.timeoutsPurchase.length; i++) {
      clearTimeout(this.timeoutsPurchase[i]);
    }
  },

  methods: {

    getServiceFee () {
      if (this.getChoicedCompany.service_fee) {
        return this.getChoicedCompany.service_fee
      } else {
        return 0
      }
    },

    setFirstSchedule (s, time) {
      console.log(s, time)
      this.firstScheduleInfo = s
      this.firstScheduleTime = time
      this.lastSelectedInfo = s
      this.lastSelectedTime = time
      this.$forceUpdate()
    },

    startCheckout () {
      if (UserConn.isLoggedIn()) {
        window.scrollTo(0, 0)
        this.coverCheckout = true
      } else {
        this.$router.push({path: '/login'})
      }
    },

    openCVV () {
      if (!this.validateAddress() && !this.validateCard() && this.selectedCard && this.mayIFinish){
        this.cvvModal = true
        this.$nextTick(() => {
          this.$refs.cvvInput.focus()
        })
      } else {
        if (this.invalidAddress) {
          EventBus.$emit('showAlert', 'error', 'O endereço é obrigatório para compras no Brasil.')
        } else if (this.invalidCard || !this.selectedCard) {
          EventBus.$emit('showAlert', 'error', 'Selecione um cartão de crédito.')
        } else if (!this.mayIFinish) {
          if (this.isMinimumPriceAccepted ()) {
            EventBus.$emit('showAlert', 'warning', 'Endereço fora de área de cobertura.')
          } else {
            // the minumum price will troll alert
          }
        }
      }
    },

    async checkout () {
      this.cvvModal = false
      if (this.validateForm()) {
        this.$store.state.showLoading = true
        let result = await CartConn.checkout(
          this.$store.state.checkoutViewCVV,
          this.$store.state.checkoutViewSelectedAddress,
          this.$store.state.checkoutViewSelectedCard,
          (this.delivery === 'true'),
          this.scheduleInfo,
          this.scheduleTime,
          (this.$store.state.cupomObject ? this.$store.state.cupomObject.code : null),
          this.$store.state.cart.cupomDiscount
        )
        if (!result.error && result.transaction_id) {
          //this.$router.push({path: '/finishCheckout'})
          console.log(result)
          this.updateTransactions(result.transaction_id)
          // try get the purchase status
        } else {
          //console.log(result)
          this.$store.state.showLoading = false
          EventBus.$emit('showAlert', 'error', result.msg)
        }
        this.$store.state.checkoutViewCVV = null
      }
    },

    async updateTransactions (transactionId) {
      console.log('update transactions')
      let transactions = await TransactionConn.getAll()
      if (!transactions.error) {
        let transaction = transactions.filter(t => t.Id === transactionId)
        console.log('transaction filtered -> ', transaction)
        if (transaction.length && transaction[0].Status === 2 ){
          this.$store.state.showLoading = false
          this.$router.push({path: '/ongoing'})
          this.clearCart()
        } else if (transaction.length && transaction[0].Status === 3) {
          this.$store.state.showLoading = false
          EventBus.$emit('showAlert', 'error', 'Pagamento Rejeitado')
        } else if (this.retry < 15) {
          console.log('update transactions RETRY no: ' + this.retry + ' -- id ->  ' + transactionId)
          this.retry = this.retry + 1
          this.timeoutsPurchase.push(setTimeout(() => this.updateTransactions(transactionId), 2000))
        } else {
          console.log('ERROR NOT EXPECTED')
          EventBus.$emit('showAlert', 'info', 'Erro ao obter o status do Pedido.')
          this.$store.state.showLoading = false
          this.clearCart()
          this.$router.push({path: '/history'})
        }
      } else {
        EventBus.$emit('showAlert', 'info', 'Erro ao obter o status do Pedido.')
        this.$store.state.showLoading = false
        this.clearCart()
        this.$router.push({path: '/history'})
      }
    },

    priceConditionals(product) {
      console.log(product)
      let foodOptions = 0
      // remove options price from unity
      if (product.options) {
        product.options.forEach((o) => {
          o.choices.forEach((c) => {
            if (c.price) {
              foodOptions += (c.price * c.quantity)
            }
          })
        })
      }
      if (product.originalPrice === product.price - foodOptions) {
        return 'R$ ' + this.formatPrice(product.price - foodOptions) + ' / unidade'
      } else {
        return '<span style="text-decoration: line-through;font-size:12px;color:#555;">R$ ' + this.formatPrice(product.originalPrice) +  '</span> R$ ' + this.formatPrice(product.price - foodOptions) + ' / unidade'
      }
    },

    isMinimumPriceAccepted () {
     if (this.getChoicedCompany.delivery_properties) {
        if (this.getChoicedCompany.delivery_properties.minimum_purchase_value < this.$store.state.cart.total) {
          this.mayIFinish = true
        } else {
          EventBus.$emit('showAlert', 'info', 'Pedido mínimo necessário para entrega R$ ' + this.formatPrice(this.getChoicedCompany.delivery_properties.minimum_purchase_value))
          this.mayIFinish = false
        }
      } else {
        this.mayIFinish = true
      }
      return this.mayIFinish
   },

    getTotalCartPrice() {
      let price =  Number(this.$store.state.cart.deliveryTax)
      if (Number(this.$store.state.cart.total) - Number(this.$store.state.cart.cupomDiscount) > 0 ) {
        price = price + Number(this.$store.state.cart.total) - Number(this.$store.state.cart.cupomDiscount)
      }
      return this.formatPrice(price + this.getServiceFee())
    },

    /** delivery type check */

    calculateEstimateExpress () {
      let estimateStr = ''
      let min = this.getChoicedCompany.open_express_from
      let max = this.getChoicedCompany.close_express_to
      let estimate = this.getChoicedCompany.time_express
      if (min && max && estimate) {
        let now = new Date().getHours()
        let minuteOrHours = ''

        if (estimate <= 60){
          minuteOrHours = estimate + ' minutos'
        } else {
          minuteOrHours = parseInt(estimate/60) + (parseInt(estimate/60) > 1 ? ' horas' : ' hora')
        }
        if (now >= max) {
          if (this.getChoicedCompany.agenda) {
            console.log('expired date schedule')
            estimateStr = this.firstScheduleInfo
            this.scheduleInfo = estimateStr
            this.scheduleTime = this.firstScheduleTime
          } else {
            console.log('expired date')
            let dt = new Date()
            dt.setDate(dt.getDate() + 1)
            estimateStr = dt.getDate() + '/' + Number(dt.getMonth() + 1) + ' às ' + min + (min > 1 ? ' horas' : ' hora')
            let timeSchedule = this.dt
            timeSchedule.setHours(min)
            timeSchedule.setMinutes(0)
            timeSchedule.setSeconds(0)
            this.scheduleInfo = estimateStr
            this.scheduleTime = timeSchedule.getTime()
          }
        } else {
          estimateStr = minuteOrHours
          this.scheduleInfo = null
          this.scheduleTime = null
        }
      }
      return estimateStr
    },

    isSelectDeliveryType (format) {
      if (format === this.deliveryType) {
        return true
      } else {
        return false
      }
    },

    async selectDeliveryType (format) {
      if (format !== this.deliveryType) {
        if (format === 'delivery_express' || format === 'delivery_schedule'){
          this.delivery = 'true'
        } else {
          this.delivery = false
        }
        if (format === 'delivery_schedule') {
          this.deliveryType = format
          // wait validation to confirm if schedule will be accepted
          await this.validateIfDelivery(true)
          if (this.deliveryType !== 'delivery_take') {
            this.scheduleModal = true
            // change option
            this.scheduleTime = this.lastSelectedTime
            this.scheduleInfo = this.lastSelectedInfo
          }
        } else {
          this.deliveryType = format
          this.validateIfDelivery(true)
        }
      }
    },

    isStoreTaking () {
      if (this.getChoicedCompany.delivery_properties) {
        this.mayIChoiceDelivery = (this.getChoicedCompany.delivery_properties.store_taking === 'true' || this.getChoicedCompany.delivery_properties.store_taking === true)
        return this.getChoicedCompany.delivery_properties.store_taking
      } else {
        this.mayIChoiceDelivery = true
        return true
      }
    },

    async validateIfDelivery (advise) {
      if (!this.isStoreTaking()){
        this.delivery = 'true'
      }
      if (this.delivery === 'true' && this.$store.state.checkoutViewSelectedAddress && this.$store.state.checkoutViewSelectedAddress !== '0') {
        this.$store.state.showLoading = true
        let addrs = this.$store.state.user.adresses.filter(a => a.id === this.$store.state.checkoutViewSelectedAddress)
        let addr = addrs[0]
        let resultDelivery = await LocConn.getDeliveryFee(addr.id)
        if (!resultDelivery.error) {
          if (resultDelivery.delivery_fee !== null && resultDelivery.allow_delivery) {
            if (this.isMinimumPriceAccepted()) {
              this.updateWillDelivery(true, resultDelivery, advise)
            } else {
              this.updateWillDelivery(false, null, advise, true)
            }
          } else if (!resultDelivery.allow_delivery) {
            this.updateWillDelivery(false, null, advise)
          }
        } else {
          EventBus.$emit('showAlert', 'error', resultDelivery.msg)
        }
        this.$store.state.showLoading = false
      } else {
        this.$nextTick(() => {
          this.delivery = false
          this.deliveryType = 'delivery_take'
          this.$store.state.cart.deliveryTax = 0.00
          this.$forceUpdate()
        })
      }
    },

    updateWillDelivery (will, resultDelivery, advise, minimunPrice) {
      if (will) {
        this.$store.state.cart.deliveryTax = resultDelivery.delivery_fee
        this.delivery = 'true'
        this.infoDelivery = ''
        this.infoFinish = ''
        this.mayIFinish = true
      } else {
        if (minimunPrice) {
          if (advise && this.coverCheckout) {
            EventBus.$emit('showAlert', 'warning', 'Para entrega: O pedido mínimo para entrega é de R$ ' + this.formatPrice(this.getChoicedCompany.delivery_properties.minimum_purchase_value))
          }
          if (this.isStoreTaking()) {
            this.mayIFinish = true
            this.deliveryType = 'delivery_take'
            this.$store.state.cart.deliveryTax = 0.00
          } else {
            this.mayIFinish = false
          }
        } else {
          if (this.isStoreTaking()) {
            this.mayIFinish = true
            if (advise && this.coverCheckout) {
              EventBus.$emit('showAlert', 'warning', 'Este endereço está fora da área de cobertura. Você poderá apenas retirar em loja')
            }
            this.deliveryType = 'delivery_take'
            this.$store.state.cart.deliveryTax = 0.00
          } else {
            this.mayIFinish = false
            if (advise && this.coverCheckout) {
              EventBus.$emit('showAlert', 'warning', 'Este endereço está fora da área de cobertura. Escolha outro endereço')
            }
          }
        }
        this.delivery = false
        this.$forceUpdate()
      }

      
    },
    
    setSchedule (scheduleinfo, time) {
      this.scheduleInfo = scheduleinfo
      this.scheduleTime = time
      this.scheduleModal = false
      this.lastSelectedInfo = scheduleinfo
      this.lastSelectedTime = time
    },

    /** Address */
    selectAddress (addr) {
      if (addr) {
        this.selectedAddr = this.$store.state.user.adresses.filter(a => a.id === addr)[0]
        this.$store.state.checkoutViewSelectedAddress = this.selectedAddr.id
      }
      this.addressModal = false
      if (this.$store.state.cart.products.length) {
        this.validateIfDelivery(true)
      }
    },

    newAddress () {
      this.$store.state.newAddressOrigin = 'cart'
      this.$router.push({path:'/address'})
    },

    getPinAddress () {
      let addrTake = ''
      this.getChoicedCompany.pinAdresses.forEach((pin) => {
        if (pin.retrieve === true || pin.retrieve === 'true') {
          addrTake = addrTake + '<li>' + pin.address
        }
      })
      return addrTake
    },

    /** cards */

    selectCard (card) {
      if (card) {
        this.$store.state.checkoutViewSelectedCard = card
        this.selectedCard = this.$store.state.user.cards.filter(a => a.id === card)[0]
      }
      //console.log(card)
      this.cardModal = false
    },

    newCard () {
      this.$store.state.newCardOrigin = 'cart'
      this.$router.push('/card')
    },

    /* CUPOM */
    async validateCupom () {
      console.log('VALIDATE CUPOM')
      this.$store.state.showLoading = true
      let result = await PromotionsConn.validateVoucher(this.$store.state.cupomCode)
      if (!result.error) {
        this.$store.state.showLoading = false
        this.cupomsModal = false
        this.$store.state.cupomObject = result
        await this.updateCartCupom()
        console.log(this.$store.state.cupomObject)
      } else {
        this.$store.state.cupomObject = null
        await this.updateCartCupom()
        this.$store.state.showLoading = false
        EventBus.$emit('showAlert', 'error', 'Cupom inválido.')
      }
      
    },

    async removeCupom () {
      this.$store.state.cupomObject = null
      await this.updateCartCupom()
    },

    /** form validation */
    validateForm () {
      if (!this.validateAddress() &&
          !this.validateCard() &&
          !this.validateCvv()
      ) { return true } else { return false }
    },
    validateAddress () {
      this.invalidAddress = !this.$store.state.checkoutViewSelectedAddress || this.$store.state.checkoutViewSelectedAddress === "0"
      if (this.invalidAddress) {
         EventBus.$emit('showAlert', 'error', 'Endereço inválido.')
      }
      //console.log(this.invalidAddress)
      return this.invalidAddress
    },
    validateCard () {
      this.invalidCard = !this.$store.state.checkoutViewSelectedCard || this.$store.state.checkoutViewSelectedCard === "0"
      if (this.invalidCard) {
         EventBus.$emit('showAlert', 'error', 'Cartão de crédito inválido.')
      }
      //console.log(this.invalidCard, this.$store.state.checkoutViewSelectedCard)
      return this.invalidCard
    },
    validateCvv () {
      this.invalidCVV = !this.$store.state.checkoutViewCVV || this.$store.state.checkoutViewCVV.length < 3
      if (this.invalidCVV) {
         EventBus.$emit('showAlert', 'error', 'CVV inválido.')
      }
      return this.invalidCVV
    }

  }
}
</script>

<style lang="scss">

@import "@/css/_variables.scss";


.newcart_container {
  background-color: #ffffff;
  width:100vw;
  position:relative;
}

.new_cart_items_list {
  margin: 0px auto;
  max-width:$tablet;
}

.newcart_title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;

  color: #121C2A;
}

.newcart_product_name {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #121C2A;
  text-transform: capitalize;
}
.newcart_product_price {
  font-family: Roboto;
  font-style: normal;
  font-size: 14px;
  line-height: 20px;

  color: #121C2A;
}

.newcart_minus {
  width:32px;
  height:24px;
  border-radius: 3px 0 0 3px;
  background: #FAFAFA;
  border: 1px solid #E6E7EB;
  cursor:pointer;
}

.newcart_plus {
  width:32px;
  height:24px;
  border-radius: 0 3px 3px 0;
  background: #FAFAFA;
  border: 1px solid #E6E7EB;
}

.newcart_quantity {
  width:40px;
  height:24px;
  background: #FAFAFA;
  border-top: 1px solid #E6E7EB;
  border-bottom: 1px solid #E6E7EB;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #6b6b6b;
  cursor:pointer;
}


.newcart_imageprod {
  max-width:calc( 100% );
  max-height:60px;
}

.newcart_pay_button {
  width:100%;
  max-width:311px;
  border-radius: 6px;
  height:44px;
  border:0px;
  color:#ffffff;
}

.newcart_pay_button_wire {
  width:100%;
  max-width:311px;
  background: #ffffff;
  border-radius: 6px;
  height:44px;
  border:0px;
}


.newcart_cover_oppen {
  height: 100vh;
  width:100vw;
  top:0vh;
  left:0;
  z-index:11000;
  position:absolute;
  -webkit-transition: top 0.2s linear;
  -moz-transition: top 0.2s linear;
  -ms-transition: top 0.2s linear;
  -o-transition: top 0.2s linear;
  transition: top 0.2s linear;
}

.newcart_cover_checkout {
  height: 100vh;
  width: 100vw;
  top:130vh;
  left:0;
  z-index:11000;
  position:absolute;
  -webkit-transition: top 0.2s linear;
  -moz-transition: top 0.2s linear;
  -ms-transition: top 0.2s linear;
  -o-transition: top 0.2s linear;
  transition: top 0.2s linear;
}

.covercheckout_dimiss {
  height:60px;
  text-align:center;
  box-shadow: 0px 5px 9px rgba(18, 28, 42, 0.09);
}

.newcart_box_delivery_choice {
  background: #F7F7F8;
  border-radius: 6px;
  height: 85px;
  width:100%;
  cursor:pointer;
}

.selectec_shadow {
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.15), inset 0px -1px 0px rgba(7, 10, 15, 0.15);
}
</style>
